module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_banco_tokyo_sipat_01.e1238eb9.jpg";